








































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ShareIcon extends Vue {
  @Prop({ default: '18' }) readonly width?: string;
  @Prop({ default: '18' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
